import { useEffect, useState } from "react"
import { Toaster as SonnerToaster } from "sonner"

// sonner's `toast()` is a SINGLE global event bus: every mounted <Toaster>
// subscribes to it, so N mounted Toasters render every toast N times. We must
// therefore render exactly ONE sonner <Toaster> per JS context (= per document:
// the web SPA, the popup, the new-tab page, and the WhatsApp content script each
// load their own bundle instance, hence their own module scope below).
//
// This module-level flag makes the first-mounted <Toaster> the sole owner and
// turns every additional instance into a no-op, so the "one Toaster per document"
// guarantee holds structurally even if a stray <Toaster> ever slips into a nested
// provider again. In practice each root mounts exactly one persistent <Toaster>,
// so the owner never unmounts and this guard is pure defense-in-depth.
let toasterOwned = false;

export function Toaster() {
  const [owns, setOwns] = useState(false);

  useEffect(() => {
    if (toasterOwned) return;
    toasterOwned = true;
    setOwns(true);
    return () => {
      toasterOwned = false;
    };
  }, []);

  if (!owns) return null;

  return (
    <SonnerToaster
      position="top-right"
      richColors
      toastOptions={{
        duration: 5000,
      }}
    />
  )
}